import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type {
  VehicleVm,
  VehicleListItem,
  VehicleListResponse,
  VehicleTypeOption,
} from '@/api/types/vehicle.types'

export class VehicleService {
  async getVehicleTypes(): Promise<VehicleTypeOption[]> {
    const url = endpoints.vehicle.getVehicleTypes
    const res = await apiClient.get<VehicleTypeOption[] | { data: VehicleTypeOption[] }>(url)
    const raw = res.data as any
    if (Array.isArray(raw)) return raw as VehicleTypeOption[]
    if (raw && typeof raw === 'object' && Array.isArray(raw.data)) return raw.data as VehicleTypeOption[]
    return []
  }

  async getAll(
    branchId: number,
    empId: number,
    pageNumber: number = 1,
    pageSize: number = 1000
  ): Promise<VehicleListResponse> {
    const url = endpoints.vehicle.getAll(branchId, empId, pageNumber, pageSize)
    console.log('[Vehicle] GET_ALL request:', { url, branchId, pageNumber, pageSize, empId })
    const res = await apiClient.get<VehicleListResponse | VehicleListItem[] | { data: VehicleListItem[] }>(url)
    const raw = res.data as any
    if (raw && Array.isArray(raw.data)) {
      console.log('[Vehicle] GET_ALL response:', { totalRecords: raw.totalRecords, count: raw.data.length })
      return {
        data: raw.data,
        totalRecords: raw.totalRecords ?? raw.data.length ?? 0,
        pageNumber: 1,
        pageSize: raw.data.length,
      }
    }
    if (Array.isArray(raw)) {
      return {
        data: raw as VehicleListItem[],
        totalRecords: (raw as VehicleListItem[]).length,
        pageNumber: 1,
        pageSize: (raw as VehicleListItem[]).length,
      }
    }
    return { data: [], totalRecords: 0, pageNumber: 1, pageSize: 0 }
  }

  async getById(id: number): Promise<VehicleVm> {
    const url = endpoints.vehicle.getById(id)
    const res = await apiClient.get<VehicleVm | { data: VehicleVm }>(url)
    const raw = res.data as any
    if (raw && typeof raw === 'object' && 'data' in raw) return raw.data as VehicleVm
    return raw as VehicleVm
  }

  async getByEmpId(empId: number): Promise<VehicleListItem[]> {
    const url = endpoints.vehicle.getByEmpId(empId)
    const res = await apiClient.get<VehicleListItem[] | { data: VehicleListItem[] }>(url)
    const raw = res.data as any
    if (Array.isArray(raw)) return raw as VehicleListItem[]
    if (raw && typeof raw === 'object' && 'data' in raw && Array.isArray(raw.data)) {
      return raw.data as VehicleListItem[]
    }
    return []
  }

  async save(payload: VehicleVm): Promise<unknown> {
    const url = endpoints.vehicle.save
    console.log('[Vehicle] SAVE payload:', { url, payload })
    const res = await apiClient.post(url, payload)
    console.log('[Vehicle] SAVE response:', res.data)
    return res.data
  }

  async update(payload: VehicleVm): Promise<unknown> {
    const url = endpoints.vehicle.update
    console.log('[Vehicle] UPDATE payload:', { url, payload })
    const res = await apiClient.put(url, payload)
    console.log('[Vehicle] UPDATE response:', res.data)
    return res.data
  }

  async delete(id: number): Promise<void> {
    const url = endpoints.vehicle.delete(id)
    await apiClient.delete(url)
  }
}

export const vehicleService = new VehicleService()
